var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.recette
    ? _c("div", [
        _c("div", { staticClass: "card-header flex-center-space-between" }, [
          _vm._v(" " + _vm._s(_vm.recette.nom) + " "),
          _c("div", { staticClass: "flex-center-space-between" }, [
            !_vm.routeMenus && (_vm.profilIsAdmin || !_vm.recette.lectureSeule)
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Modifier la recette",
                          placement: "top"
                        },
                        expression:
                          "{ content: 'Modifier la recette', placement: 'top' }"
                      }
                    ],
                    staticClass: "btn btn-success btn-sm",
                    on: {
                      click: function($event) {
                        return _vm.routeRecetteEdition()
                      }
                    }
                  },
                  [_vm._v(" Modifier ")]
                )
              : _vm._e(),
            !_vm.routeMenus
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Dupliquer la recette",
                          placement: "top"
                        },
                        expression:
                          "{ content: 'Dupliquer la recette', placement: 'top' }"
                      }
                    ],
                    staticClass: "btn btn-success btn-sm",
                    staticStyle: { "margin-left": "6px" },
                    on: {
                      click: function($event) {
                        return _vm.dupliquerRecette()
                      }
                    }
                  },
                  [_vm._v(" Dupliquer ")]
                )
              : _vm._e(),
            !_vm.routeMenus &&
            (_vm.estPerso || _vm.estCuisine || _vm.profilIsAdmin)
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: "Supprimer la recette",
                          placement: "top"
                        },
                        expression:
                          "{ content: 'Supprimer la recette', placement: 'top' }"
                      }
                    ],
                    staticClass: "btn btn-danger btn-sm",
                    staticStyle: { "margin-left": "6px" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.destroy(_vm.recette.id, _vm.recette.nom)
                      }
                    }
                  },
                  [_vm._v(" Supprimer ")]
                )
              : _vm._e()
          ])
        ]),
        _c(
          "div",
          { staticClass: "card-body", staticStyle: { background: "white" } },
          [
            _vm.recette.pourNombre &&
            _vm.recette.up &&
            _vm.recette.prixTotal &&
            _vm.composanteEffectif &&
            _vm.composanteEffectif !== _vm.recette.pourNombre
              ? _c("div", { staticStyle: { "text-align": "right" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: { "font-weight": "bolder", color: "#2baf7f" }
                    },
                    [_vm._v(_vm._s(_vm.prixBaseSurComposanteMenu))]
                  )
                ])
              : _vm._e(),
            _vm.recette.pourNombre && _vm.recette.up && _vm.recette.prixTotal
              ? _c(
                  "div",
                  { staticClass: "push-bottom-1rem flex-center-space-between" },
                  [
                    _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                      _vm._v(
                        "PAR " +
                          _vm._s(
                            _vm.recette.up === "Personnes"
                              ? "PERSONNE"
                              : _vm.recette.up
                          ) +
                          " " +
                          _vm._s(
                            _vm._f("afficherPrix")(
                              _vm.recette.prixTotal / _vm.recette.pourNombre
                            )
                          ) +
                          " "
                      )
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bolder",
                          "text-align": "right"
                        }
                      },
                      [
                        _vm._v(
                          "POUR " +
                            _vm._s(_vm.recette.pourNombre) +
                            " " +
                            _vm._s(_vm.recette.up) +
                            " " +
                            _vm._s(
                              _vm._f("afficherPrix")(_vm.recette.prixTotal)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "push-bottom-1rem" },
              [
                _c("RecetteListeIngredients", {
                  key: _vm.recette.id,
                  attrs: { recette: _vm.recette }
                })
              ],
              1
            ),
            _vm.recette.regimeIds && _vm.recette.regimeIds.length !== 0
              ? _c("div", { staticClass: "push-bottom-1rem" }, [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Régimes alimentaires incompatibles")
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idsToSentence(_vm.recette.regimeIds, "regimes")
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.textureIds && _vm.recette.textureIds.length !== 0
              ? _c("div", { staticClass: "push-bottom-1rem" }, [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Textures incompatibles")
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idsToSentence(_vm.recette.textureIds, "textures")
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.categorieRecetteId
              ? _c("div", { staticClass: "push-bottom-1rem" }, [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Catégorie")
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idToWord(
                          _vm.recette.categorieRecetteId,
                          "categorieRecettes"
                        )
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.zonePreparationId
              ? _c("div", { staticClass: "push-bottom-1rem" }, [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Zone de préparation")
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idToWord(
                          _vm.recette.zonePreparationId,
                          "zonesPreparations"
                        )
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.gemrcnIds && _vm.recette.gemrcnIds.length !== 0
              ? _c("div", [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Catégories GEMRCN")
                  ]),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.idsToSentence(_vm.recette.gemrcnIds, "gemrcn")
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.allergenes && _vm.recette.allergenes.length !== 0
              ? _c("div", [
                  _c("span", { staticClass: "titre-gras" }, [
                    _vm._v("Allergènes")
                  ]),
                  _vm._v(" (suivant vos favoris produits)"),
                  _c("br"),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.recette.allergenes
                          .map(function(x) {
                            return _vm.nomAllergene(x)
                          })
                          .join(", ")
                      ) +
                      " "
                  )
                ])
              : _vm._e(),
            _vm.recette.saisieAllergenesIncomplete
              ? _c("div", { staticClass: "error" }, [
                  _vm._v(
                    "Attention, la liste des allergènes est peut-être incomplète car ils n'ont pas été renseignés pour un ou plusieurs ingrédients "
                  )
                ])
              : _vm._e(),
            _vm._m(0)
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "padding-top": "15px", "font-size": "0.8em" } },
      [
        _c("em", [
          _vm._v(
            "L’affichage des allergènes est effectué à titre informatif. Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés."
          ),
          _c("br"),
          _vm._v(
            " En cas d’erreur, l’utilisateur ne pourra pas engager la responsabilité de la société Agap’pro, éditrice du logiciel."
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }